import { render } from "./ServicesDatatableTDCost.vue?vue&type=template&id=0098c69f"
import script from "./ServicesDatatableTDCost.vue?vue&type=script&lang=js"
export * from "./ServicesDatatableTDCost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__